var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":("/locations/" + (_vm.menuCategory.mId) + "/menu/categories/" + (_vm.menuCategory.cloverId))}},[_c('menu-card',{attrs:{"title":_vm.menuCategory.name,"imageUrl":_vm.menuCategory.imagePath}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }